import { render, staticRenderFns } from "./DianxingCesuoPinglun.vue?vue&type=template&id=08c43d2e&scoped=true&"
import script from "./DianxingCesuoPinglun.vue?vue&type=script&lang=js&"
export * from "./DianxingCesuoPinglun.vue?vue&type=script&lang=js&"
import style0 from "./DianxingCesuoPinglun.vue?vue&type=style&index=0&id=08c43d2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c43d2e",
  null
  
)

export default component.exports